import React, { Dispatch, SetStateAction, useContext } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { usePrivileges } from '../../../Auth/usePrivileges';
import { LotDetailContext } from '../../../Contexts/LotDetailContext';
import ClickableTextBox from '../../../Components/ClickableTextBox';
import { ProcessingStatus } from '../../../Types/Lot';

import './LotStatusControls.css';

export interface LotStatusControlProps {
    setShowSetLotStatusDialog: Dispatch<SetStateAction<boolean>>,
}

export const LotStatusControl = ({ setShowSetLotStatusDialog }: LotStatusControlProps) => {
    const { t } = useTranslation()
    const {
        lotDetail: {
            summary: {
                currentStatus
            }
        }
    } = useContext(LotDetailContext);
    const { admin } = usePrivileges();

    return (
        <Form.Group as={Col} className="col-sm-6" controlId="formLotStatus">
            <Row>
                <Form.Label column sm={4}>{t('LotDetails.Summary.LotStatus')}:</Form.Label>
                <Col sm={8}>
                    <ClickableTextBox value={t('LotStatus.' + currentStatus)}
                        disabled={!admin}
                        onClick={() => setShowSetLotStatusDialog(true)}
                    />
                </Col>
            </Row>
        </Form.Group>
    );
};

export const ProcessingStatusControl = ({ setShowSetLotStatusDialog }: LotStatusControlProps) => {
    const { t } = useTranslation()
    const {
        lotDetail: {
            summary: {
                processingStatus
            }
        }
    } = useContext(LotDetailContext);
    const { admin } = usePrivileges();

    const className =
        processingStatus === ProcessingStatus.Processing ? "pulse-blue" :
        processingStatus === ProcessingStatus.Failed ? "border border-danger" : "";

    return (
        <Form.Group as={Col} className="col-sm-6" controlId="formJobStatus">
            <Row>
                <Form.Label column sm={4}>{t('LotDetails.Summary.JobStatus')}:</Form.Label>
                <Col sm={8}>
                    <ClickableTextBox value={t('LotStatus.' + processingStatus)}
                        disabled={!admin}
                        onClick={() => setShowSetLotStatusDialog(true)}
                        className={className}
                    />
                </Col>
            </Row>
        </Form.Group>
    );
}
